(function() {
    // In Action Reels
      document.addEventListener('click', function (e) {
        const btn = e.target.closest('.action-card-container button .play');
        if (btn) {
          console.log('btn-play')
          const container = btn.closest('.media-box');
          if (!container) return;

          const video = container.querySelector('video');
          const image = container.querySelector('img.card-gif');
          const btnPlay = container.querySelector('.play');
          const btnFullscreen = container.querySelector('.fullscreen-btn');

          if (!video || !image) return;

          // --- Show video, hide image, play ---
          image.classList.add('card-hidden');
          video.classList.remove('card-hidden');
          video.play();
          btnPlay.classList.add('card-hidden');
          btnFullscreen.classList.remove('card-hidden');
          video.dataset.userPlaying = "true";
        }

        const clickedVideo = e.target.closest('.media-box video');
          if (!clickedVideo) return;
        if (clickedVideo) {
          console.log('video-click')
           const isFullscreen =
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;

          if (isFullscreen) {
            return;
          }
          const container = clickedVideo.closest('.media-box');
          if (!container) return;

          const image = container.querySelector('img.card-gif');
          const btnPlay = container.querySelector('.play');
          const btnFullscreen = container.querySelector('.fullscreen-btn');

          // // --- Pause video, hide video, show image ---
          // clickedVideo.pause();
          // clickedVideo.classList.add('card-hidden');
          // image.classList.remove('card-hidden');
          // btnPlay.classList.remove('card-hidden');
          // btnFullscreen.classList.add('card-hidden');
          const userPlaying = clickedVideo.dataset.userPlaying === "true";
          if (clickedVideo.paused || !userPlaying) {
            // Play the video
            clickedVideo.play();
            clickedVideo.dataset.userPlaying = "true";
          } else {
            // Pause the video and update UI
            clickedVideo.pause();
            clickedVideo.dataset.userPlaying = "false";

            clickedVideo.classList.add('card-hidden');
            image.classList.remove('card-hidden');
            btnPlay.classList.remove('card-hidden');
            btnFullscreen.classList.add('card-hidden');
          }
        }
      });
console.log('v23')
document.addEventListener("fullscreenchange", () => {
  console.log('fullscreenchange')
  const fullscreenVideo = document.querySelector("video:is(:fullscreen)");
  if (!document.fullscreenElement && fullscreenVideo) {
    const wasPlaying = fullscreenVideo.dataset.wasPlaying === "true";
    if (wasPlaying && fullscreenVideo.paused) fullscreenVideo.play().catch(() => {});
  }
});
// Purchase Reels
              jQuery(document).ready(function ($) {
                 $('#purchaseSlide').on('init reInit afterChange', function(event, slick, currentSlide){
                let i = (currentSlide ? currentSlide : 0);
                const $prev = $(this).find('.slick-prev');
                const $next = $(this).find('.slick-next');

                $prev.toggle(i !== 0);
                $next.toggle(i !== slick.slideCount - 1);
              });
                $('#purchaseSlide').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: false,
                  // autoplay: true,
                  // autoplaySpeed: 2000,
                  nextArrow: '<button type="button" class="slick-next"><img src="//www.natpat.com/cdn/shop/files/lp-bp--dropdown-icon.svg?v=14644386716670509064" alt="" width="20"></button>',
                  prevArrow: '<button type="button" class="slick-prev"><img src="//www.natpat.com/cdn/shop/files/lp-bp--dropdown-icon.svg?v=14644386716670509064" alt="" width="20"></button>',
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                         infinite: false, 
                        arrows: false,
                        centerMode: true,
                        centerPadding: '30px', 
                      }
                    },
                    {
                      breakpoint: 375,
                      settings: {
                        centerPadding: '15px', 
                         arrows: false,
                        centerMode: true,
                         infinite: false, 
                          dots: true,
                      }
                    },
                  ]
                });
              $('#purchaseSlide').trigger('init', [$('#purchaseSlide').slick('getSlick')]);

                $('#purchaseSlide.js-mobile').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  // autoplay: true,
                  // autoplaySpeed: 2000,
                  nextArrow: '<button type="button" class="slick-next"><img src="//www.natpat.com/cdn/shop/files/lp-bp--dropdown-icon.svg?v=14644386716670509064" alt="" width="10"></button>',
                  prevArrow: '<button type="button" class="slick-prev"><img src="//www.natpat.com/cdn/shop/files/lp-bp--dropdown-icon.svg?v=14644386716670509064" alt="" width="10"></button>',
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '30px', 
                         infinite: false, 
                        dots: true,
                      }
                    },
                    {
                      breakpoint: 375,
                      settings: {
                        centerPadding: '15px', 
                        arrows: false,
                        centerMode: true,
                         infinite: false, 
                          dots: true,
                      }
                    },
                  ]
                });

                 $('#in-action-slider .slider-track').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: false,
                  arrows: false,
                  centerMode: true,
                  centerPadding: '20px', 
                  dots: true,
                  autoplay: true,
                  autoplaySpeed: 5000,
                });
                 document.addEventListener('click', function (e) {
                    const btn = e.target.closest('#purchaseSlide .with-video button .play');
                     if (btn) {
                    console.log('btn-play')
                    const container = btn.closest('.media-box');
                    if (!container) return;

                    const video = container.querySelector('video');
                    const image = container.querySelector('img.card-gif');
                    const btnPlay = container.querySelector('.play');
                    const btnFullscreen = container.querySelector('.fullscreen-btn');

                    if (!video || !image) return;

                    // --- Show video, hide image, play ---
                    image.classList.add('card-hidden');
                    video.classList.remove('card-hidden');
                    video.play();
                    btnPlay.classList.add('card-hidden');
                    btnFullscreen.classList.remove('card-hidden');
                    video.dataset.userPlaying = "true";
                  }
                 })
                // $(document).on('click', function (e) {
                //   const $target = $(e.target);

                //   // ========== Click on play button ==========
                //   const $btn = $target.closest('#purchaseSlide .with-video button .play');
                //   if ($btn.length) {
                //     console.log('btn.length')
                //     const $container = $btn.closest('.media-box');
                //     if (!$container.length) return;

                //     const $video = $container.find('video');
                //     const $image = $container.find('img.card-gif');
                //     const $btnPlay = $container.find('.play');
                //     const $btnFullscreen = $container.find('.fullscreen-btn');

                //     if (!$video.length || !$image.length) return;

                //     // --- Show video, hide image, play ---
                //     $image.addClass('card-hidden');
                //     $video.removeClass('card-hidden').get(0).play();
                //     $btnPlay.addClass('card-hidden');
                //     $btnFullscreen.removeClass('card-hidden');
                //      $video[0].dataset.userPlaying = "true";
                //     return;
                //   }

                //   // ========== Click directly on a video ==========
                //   const $clickedVideo = $target.closest('.media-box video');
                //    if (!$clickedVideo) return;
                //   if ($clickedVideo.length) {
                //      const isFullscreen =
                //       document.fullscreenElement ||
                //       document.webkitFullscreenElement ||
                //       document.mozFullScreenElement ||
                //       document.msFullscreenElement;

                //     if (isFullscreen) {
                //       return;
                //     }
                //     const $container = $clickedVideo.closest('.media-box');
                //     if (!$container.length) return;

                //     const $image = $container.find('img.card-gif');
                //     const $btnPlay = $container.find('.play');
                //     const $btnFullscreen = $container.find('.fullscreen-btn');

                //     // --- Pause video, hide video, show image ---
                //     // $clickedVideo.get(0).pause();
                //     // $clickedVideo.addClass('card-hidden');
                //     // $image.removeClass('card-hidden');
                //     // $btnPlay.removeClass('card-hidden');
                //     // $btnFullscreen.addClass('card-hidden');

                   
                //   }
                // });

  $('video').each(function () {
    const $video = $(this);

    // --- When a video starts playing ---
    $video.on('play', function () {
      const current = this; 


      $('video').each(function () {
        if (this !== current) {
          this.pause();

          // Restore UI for other videos
          const $otherContainer = $(this).closest('.media-box');
          const $otherVideo = $(this);
          const $otherImage = $otherContainer.find('img.card-gif');
          const $otherPlay = $otherContainer.find('.play');
          const $btnFullscreen = $otherContainer.find('.fullscreen-btn');

          $otherVideo.addClass('card-hidden');
          $otherImage.removeClass('card-hidden');
          $otherPlay.removeClass('card-hidden');
          $btnFullscreen.addClass('card-hidden');
        }
      });
    });
    const restoreUI = () => {
      console.log('restore ui 2')
      const $container = $video.closest('.media-box');
      const $image = $container.find('img.card-gif');
      const $btnPlay = $container.find('.play');
      const $btnFullscreen = $container.find('.fullscreen-btn');

      // $video.get(0).pause();
      document.exitFullscreen();
      $video.addClass('card-hidden');
      $image.removeClass('card-hidden');
      $btnPlay.removeClass('card-hidden');
      $btnFullscreen.addClass('card-hidden');
    };

    $video.on('ended', restoreUI);

    $video.on('timeupdate', function () {
      const video = this;
      if (video.duration && video.currentTime >= video.duration - 0.2) {
        const $container = $video.closest('.media-box');
        const $image = $container.find('img.card-gif');
        const $btnPlay = $container.find('.play');
        const $btnFullscreen = $container.find('.fullscreen-btn');

        if ($video.hasClass('card-hidden')) return; 

        $video.addClass('card-hidden');
        $image.removeClass('card-hidden');
        $btnPlay.removeClass('card-hidden');
        $btnFullscreen.addClass('card-hidden');

        const video1 = $video[0];
        video1.pause();
        video1.currentTime = 0;
      }
  });

  });
});

// Fullscreen
 document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.querySelector(".custom-fullscreen");
  const fsVideo = document.getElementById("fullscreen-video");
  const progressBar = overlay.querySelector(".progress-bar");
  const progressFill = overlay.querySelector(".progress-fill");
  const progressHandle = overlay.querySelector(".progress-handle");
  const closeBtn = overlay.querySelector(".close-btn");
  let currentVideo = null;
  let isDragging = false;

  document.querySelectorAll(".fullscreen-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const vid = btn.closest(".media-box").querySelector("video");
      if (!vid) return;
      currentVideo = vid;
      fsVideo.src = vid.querySelector("source").src;
      fsVideo.currentTime = vid.currentTime;
      overlay.classList.remove("hidden");
      fsVideo.play();
    });
  });
                
  closeBtn.addEventListener('click', () => {
    overlay.classList.add('hidden');
    if (!currentVideo) return;

  let wasPlaying = !fsVideo.paused && !fsVideo.ended;
    if (fsVideo.ended) {
      console.log('video ended')
      currentVideo.pause();
      currentVideo.currentTime = 0;
       wasPlaying = false; 
       currentVideo.dataset.pausedFullscreen  = false
      
      const container = currentVideo.closest('.media-box');
      container.querySelector('video').classList.add('card-hidden');
      container.querySelector('img.card-gif').classList.remove('card-hidden');
      container.querySelector('.play').classList.remove('card-hidden');
      container.querySelector('.fullscreen-btn').classList.add('card-hidden');

    }  else if (fsVideo.paused) {
      console.log('paused')
    currentVideo.currentTime = fsVideo.currentTime;
    currentVideo.pause();
     wasPlaying = false; 
     currentVideo.dataset.pausedFullscreen = true

    const container = currentVideo.closest('.media-box');
    container.querySelector('video').classList.remove('card-hidden');
    container.querySelector('img.card-gif').classList.add('card-hidden');
    container.querySelector('.play').classList.add('card-hidden');
    container.querySelector('.fullscreen-btn').classList.remove('card-hidden');
  } else {
     console.log('video playing')
      currentVideo.currentTime = fsVideo.currentTime;
      currentVideo.play().catch(() => {});
       wasPlaying = true;
      currentVideo.dataset.pausedFullscreen = false

      const container = currentVideo.closest('.media-box');
      container.querySelector('video').classList.remove('card-hidden');
      container.querySelector('img.card-gif').classList.add('card-hidden');
      container.querySelector('.play').classList.add('card-hidden');
      container.querySelector('.fullscreen-btn').classList.remove('card-hidden');
    }

     currentVideo.dataset.userPlaying = wasPlaying ? "true" : "false";
    fsVideo.pause();
    fsVideo.removeAttribute('src');
  });

  fsVideo.addEventListener("click", () => {
    if (fsVideo.paused) fsVideo.play();
    else fsVideo.pause();
  });

  fsVideo.addEventListener("timeupdate", () => {
    if (!fsVideo.duration || isDragging) return;
    const percent = (fsVideo.currentTime / fsVideo.duration) * 100;
    progressFill.style.width = `${percent}%`;
    progressHandle.style.left = `${percent}%`;
  });

  progressBar.addEventListener("click", (e) => {
    const rect = progressBar.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    fsVideo.currentTime = percent * fsVideo.duration;
  });

  const handleMove = (clientX) => {
    const rect = progressBar.getBoundingClientRect();
    let percent = (clientX - rect.left) / rect.width;
    percent = Math.max(0, Math.min(1, percent));
    progressFill.style.width = `${percent * 100}%`;
    progressHandle.style.left = `${percent * 100}%`;
    fsVideo.currentTime = percent * fsVideo.duration;
  };

  progressHandle.addEventListener("mousedown", () => (isDragging = true));
  document.addEventListener("mouseup", () => (isDragging = false));
  document.addEventListener("mousemove", (e) => {
    if (isDragging) handleMove(e.clientX);
  });

  progressHandle.addEventListener("touchstart", () => (isDragging = true));
  document.addEventListener("touchend", () => (isDragging = false));
  document.addEventListener("touchmove", (e) => {
    if (isDragging) handleMove(e.touches[0].clientX);
  });
  const resizeFullscreenVideo = () => {
  if (!overlay.classList.contains('hidden')) {
    fsVideo.style.width = `${window.innerWidth}px`;
    fsVideo.style.height = `${window.innerHeight}px`;
  }
};
window.addEventListener('resize', resizeFullscreenVideo);
window.addEventListener('orientationchange', resizeFullscreenVideo);
});


})();
